import script from "./password.vue?vue&type=script&lang=ts&setup=true"
export * from "./password.vue?vue&type=script&lang=ts&setup=true"

import "./password.vue?vue&type=style&index=0&id=18f17272&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f17272"]])

export default __exports__